import { useQuery } from '@apollo/client/react';
import { useMediaQuery, useTheme } from '@mui/material';

import { ApolloError } from 'common/components/ApolloError';
import {
    MenuItemsDocument,
    OrganisationDocument,
    IMainMenu,
    IFeature,
} from 'graphql/types';
import { useFeature } from 'common/hooks/useFeature';

import { MobileNavigation } from './MobileNavigation';
import { Navigation } from './Navigation';

export const MainNavigation = () => {
    const { data, error } = useQuery(MenuItemsDocument);
    const { data: organisationData } = useQuery(OrganisationDocument);
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const { canUse: canUseSkillsFeature, showSkills } = useFeature(
        IFeature.Skill,
        true
    );
    const canUseSkills = canUseSkillsFeature && showSkills;

    const organisation = organisationData?.organisation;

    const hasIntroduction =
        !!organisation?.participantIntroImage ||
        !!organisation?.participantIntroTitle ||
        !!organisation?.participantIntroText;

    if (error) return <ApolloError error={error} />;

    if (!data?.menuItems?.length) return null;

    // Spread menuItems so it can be ordered
    const menuItems = [...data.menuItems];

    // Always make management upgrade plan and profileMenu the last ones, we use the indexes
    // to splice them and push them into the array.
    const managementMenuIndex = menuItems.findIndex(
        (item) => item.menu === IMainMenu.Management
    );

    menuItems.push(menuItems.splice(managementMenuIndex, 1)[0]);

    // If not mobile
    if (isSmUp) {
        const createMaterialMenuIndex = menuItems.findIndex(
            (item) => item.menu === IMainMenu.CreateMaterial
        );

        // Move button to the last position in navigation
        menuItems.push(menuItems.splice(createMaterialMenuIndex, 1)[0]);
    }

    const profileMenuIndex = menuItems.findIndex(
        (item) => item.menu === IMainMenu.Profile
    );

    menuItems.push(menuItems.splice(profileMenuIndex, 1)[0]);

    // Put notifications menu item at the end of the menu
    const notificationsMenuIndex = menuItems.findIndex(
        (item) => item.menu === IMainMenu.Notifications
    );

    menuItems.push(menuItems.splice(notificationsMenuIndex, 1)[0]);

    return (
        <>
            <Navigation
                canUseSkills={canUseSkills}
                hasIntroduction={hasIntroduction}
                menuItems={menuItems}
            />
            <MobileNavigation
                hasIntroduction={hasIntroduction}
                menuItems={menuItems}
            />
        </>
    );
};
